import { createSelector } from "reselect";

export const selectUser = (state) => state.user || {};

export const makeSelectUnits = () => createSelector(selectUser, ({ units }) => units);

export const selectUserUid = createSelector([selectUser], (user) => user.uid);

export const selectCodeLib = createSelector([selectUser], (user) => user.codeLib);

export const selectUsersOrganization = createSelector([selectUser], (user) => user.organization);

export const selectUserOrgLoading = createSelector([selectUser], (user) => user.orgLoading || false);

export const selectUserName = createSelector([selectUser], (user) => user.name || "");

export const selectUserModelDir = createSelector([selectUser], (user) => user.modelDir || {});

export const selectUserModelDirLoading = createSelector([selectUser], (user) => user.modelDirLoading || false);

export const selectUserError = createSelector([selectUser], (user) => user.error);

export const selectUserCommDir = createSelector([selectUser], (user) => user.commDir || {});

export const selectUserCommDirLoading = createSelector([selectUser], (user) => user.commDirLoading || false);

export const selectParametricDir = createSelector([selectUser], (user) => user.parametricDir || {});

export const selectIsParametricDirLoading = createSelector(
    [selectUser],
    (user) => user.isParametricDirLoading || false
);

export const selectUserCreditSummary = createSelector([selectUser], (user) => user.creditSummary || {});

export const selectUserPermissions = createSelector([selectUser], (user) => user.userPermissions || {});

export const selectUserPreferences = createSelector([selectUser], (user) => user.userPreferences || {});

export const selectUserCredits = createSelector([selectUser], ({ creditSummary = {} }) => creditSummary);

export const selectAllowPayments = createSelector([selectUser], (user) => Boolean(user.allowPayments));

export const selectIsUserVerified = createSelector([selectUser], (user) => user.isUserVerified || false);

export const selectFavouriteHiddenRows = createSelector(
    [selectUserPreferences],
    (prefs) => prefs.favouriteHiddenRows || {}
);
